import { omit } from 'lodash';
import { Link, MarkedText, Tooltip, Typography } from '@common-components';
import { SubmissionMarketRequestStatus } from 'enums';
import { ActivityLog, ExtendedMarketRequest } from 'types';
import { ConditionalWrap, truncateMultiLineText } from 'utils';
import Indication from './IndicationPopUp/Indication';
import InformationRequest from './InformaitionRequestPopUp/InformationRequest';
import { useGetQuoteMetadataData } from './useGetQuoteMetadataData';

export interface MarketRequestMetaDataProps {
  marketRequest: ExtendedMarketRequest;
  emailActivity?: ActivityLog;
}

export default function MarketRequestMetaData({ marketRequest, emailActivity }: MarketRequestMetaDataProps) {
  const { title, description, titleTextAfterLink, linkProps, isAIExtracted } = useGetQuoteMetadataData(
    marketRequest,
    emailActivity,
  );

  const informationRequestedText = marketRequest.informationRequested.join(', ');

  return (
    <>
      {marketRequest.status === SubmissionMarketRequestStatus.Declined ||
      marketRequest.status === SubmissionMarketRequestStatus.Indication ? (
        <Indication marketRequest={marketRequest} />
      ) : (
        <>
          <Typography variant="body2" color="text.primary" title={title} sx={{ ...truncateMultiLineText(4) }}>
            <ConditionalWrap
              condition={!!isAIExtracted}
              wrap={(wrappedChildren) => <MarkedText>{wrappedChildren}</MarkedText>}
            >
              <>
                {title}{' '}
                {linkProps && (
                  <Tooltip tooltipContent={linkProps.linkTooltip || ''} placement="top">
                    <Link color="primary" sx={{ cursor: 'pointer' }} {...omit(linkProps, 'linkText')}>
                      {linkProps.linkText}
                    </Link>
                  </Tooltip>
                )}
                {linkProps && titleTextAfterLink ? titleTextAfterLink : ''}
              </>
            </ConditionalWrap>
          </Typography>
          {description && <Typography variant="caption">{description}</Typography>}
        </>
      )}

      {informationRequestedText && <InformationRequest marketRequest={marketRequest} />}
    </>
  );
}
